<template>
  <main
    class="container mx-auto xl:container md:container lg:mx-auto my-32 px-4 lg:pb-10"
  >
    <div
      class="flex flex-col"
      style="cursor: pointer"
      v-for="(record, i) in predictions"
      :key="i"
      @click="click(record._id)"
    >
      <div class="flex flex-col sm:flex-row mt-8">
        <img
          class="md:w-6/12 lg:w-1/4 h-48"
          :src="record.image"
          alt="media record"
        />
        <div class="flex flex-col sm:ml-5">
          <div class="font-semibold text-sm md:text-xl w-full uppercase">
            {{ record.description }}
          </div>
          <div
            class="text-lightPurple text-sm font-semibold flex items-center mt-8"
          >
            <img
              class="w-8 h-8 mr-3"
              :src="require('@/assets/images/docs.svg')"
              alt=""
            />
            Event ID: {{ record._id }}
          </div>
          <div
            class="text-lightPurple text-sm font-semibold md:text-base mt-2 uppercase"
          >
            Site location name: 30” ACT at Ebiong
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      records: [
        {
          image: "mapImage.png",
          title:
            "Sabotage and theft ongoing at the Oil base in Ebiong at Port Harcourt",
          id: "ASNQ.45678/2AA6/6722",
          location: "30” ACT at Ebiong"
        },
        {
          image: "mapImage.png",
          title:
            "Sabotage and theft ongoing at the Oil base in Ebiong at Port Harcourt",
          id: "ASNQ.45678/2AA6/6722",
          location: "30” ACT at Ebiong"
        },
        {
          image: "mapImage.png",
          title:
            "Sabotage and theft ongoing at the Oil base in Ebiong at Port Harcourt",
          id: "ASNQ.45678/2AA6/6722",
          location: "30” ACT at Ebiong"
        },
        {
          image: "mapImage2.png",
          title:
            "Security base DTLAG-122 is under attack, immediate action is required.",
          id: "ASNQ.45678/2AA6/6722",
          location: "30” ACT at Ebiong"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      predictions: "events/predictions"
    })
  },
  methods: {
    click(data) {
      this.$store.dispatch("events/clearPrediction");
      this.$store.dispatch("events/getPrediction", data);
      this.$router.push(`/media/${data}`);
    }
  }
};
</script>

<style lang="scss" scoped></style>
